import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/layout';

const Home = lazy(() => import('./components/home'));
const AboutPage = lazy(() => import('./components/aboutPage'));
const GalleryPage = lazy(() => import('./components/galleryPage'));
const ContactPage = lazy(() => import('./components/contactPage'));
const AdminPage = lazy(() => import('./components/adminPage'));

function App() {
  return (
    <Router>
      <Layout>
        <Suspense fallback={<div className="page-loading">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
